<template>
  <div
    class="flex flex-col items-center justify-center min-h-screen bg-white dark:bg-red-500"
  >
    <AnimatedWave />
  </div>
</template>

<script setup lang="ts">
useSeoMeta({
  title: "",
  description:
    "Highfield Music Studio provides classes for instruments, DJing, music production, monthly packs, and group lessons.",
  keywords:
    "studio, music, instruments, recording, audio equipment, midi, dj gear, microphones, studio equipment",
  ogTitle: "School | Highfield Music Studio",
  ogDescription:
    "Highfield Music Studio provides classes for instruments, DJing, music production, monthly packs, and group lessons.",
  ogImage: "/images/logos/studio/1.jpg",
  twitterCard: "summary_large_image",
  twitterTitle: "School | Highfield Music Studio",
  twitterDescription:
    "Highfield Music Studio provides classes for instruments, DJing, music production, monthly packs, and group lessons.",
  twitterImage: "/images/media/studio/1.jpg",
});
</script>
